import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { TEXT_ELLIPSIS } from "../../Shared/styles";

export const ReplyContainerGrid = styled(Grid)({
    borderLeft: "2px solid var(--community-color-iris-orchid)",
    flexDirection: "row",
    margin: "8px 0 0 0",
    display: "flex",
});

export const ReplyImage = styled("img")({
    width: "42px",
    height: "42px",
    objectFit: "cover",
    borderRadius: "4px",
    marginLeft: "8px",
});

export const ReplyTextContainerGrid = styled(Grid)({
    flexDirection: "column",
    marginLeft: "8px",
    lineHeight: "1.25",
    justifyContent: "center",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textAlign: "left",
});

export const ReplyUserNameTypography = styled(Typography)({
    margin: "0",
    fontWeight: "500",
    fontSize: "12px",
    color: "var(--community-color-secondary-text)",
    ...TEXT_ELLIPSIS,
});
